import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const staffService = {
  getUserStaffStatus: async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/accounts/user/check-staff/`,
        getConfig()
      );
      return response.data.is_staff;
    } catch (error) {
      console.error("Error checking user status:", error);
      throw error;
    }
  },
};
